import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";


import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import { Label, Input, FormFeedback } from 'reactstrap';


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tipo_id: null,
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }
    setSelects(data) {
        this.setState({
            tipo_id: data.tipo_id,
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.plan.subtipos.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Subtipo de Transferencia"}
                buttonTitle={"Subtipo de Transferencia"}
                buttonIcon={"fa fa-search fa-lg"}
                
                saveButton={false}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-md"}
                onGotData={(data) => this.setSelects(data)}>
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos del subtipo</p>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input type="text" name="nombre" disabled={true}></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Tipo</Label>
                                <ParadigmaAsyncSeeker disabled={true} value={this.state.tipo_id} onChange={(value) => this.setState({ tipo_id: value.pk })} fieldName={"tipo_id"} url={api.proyectos.config.plan.tipos.select} />
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Plan_SubTipos/Detail.js